import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import { getRejectedDataActionHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";
import { rejected } from "../../../../utils/mainTabs/social/rejected";

const Rejected = () => {
  const pageSize = 8;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantName } = useOutletContext();
  const [tableColumns, setTableColumns] = useState([]);
  const { searchPlaceHolder } = rejected;
  const { columns } = moderateContributions;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getRejectedDataActionHandler, pageSize);

  useEffect(() => {
    let newTableColumns = columns(
      location,
      navigate,
      dispatch,
      handleSearchQuery,
      tenantName
    );
    setTableColumns(newTableColumns);
  }, [columns, location, dispatch, navigate, tenantName]);

  return (
    <DataTable
      columns={tableColumns}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"ID"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default Rejected;
